export default __webpack_public_path__ + "static/media/img-client-mobile.d9dc361a.jpg";